// Utils & misc
import cn from '../../../utils/cn';

// Components
import Picto from '../Picto/Picto';

// Style
import style from './FavoriteToggleButton.module.css';

/**
 * FavoriteToggleButton component - Star toggle: outline when off, filled when on.
 * @param {object} params
 * @param {boolean} params.isFavorite - Favorite state (filled star)
 * @param {string} params.label - Accessible label (title and aria-label)
 * @param {() => void} params.onToggle - Click handler
 * @param {string} [params.className] - Additional CSS classes
 * @returns {JSX.Element} FavoriteToggleButton component
 */
function FavoriteToggleButton({
  isFavorite,
  label,
  onToggle,
  className,
}) {
  return (
    <button
      type="button"
      className={cn([style['favorite-toggle'], isFavorite && style.favorite, className])}
      title={label}
      aria-label={label}
      aria-pressed={isFavorite}
      onClick={onToggle}
    >
      <Picto icon={isFavorite ? 'star-filled' : 'star'} className={style.star} />
    </button>
  );
}

export default FavoriteToggleButton;
